module.exports = __webpack_public_path__ + "img/pic3@2x.bde19ae2.png";